import GreenPageSection from 'components/GreenPageSection';
import Subheading, { SubheadingColourScheme } from 'components/Subheading';
import { ASSET_PREFIX } from 'utils/constants';

const FollowUsOnInstagramGreenPageSection = () => {
  return (
    <GreenPageSection additionalClassName="followUsOnInstagramGreenPageSection">
      <img
        src={`${ASSET_PREFIX}/images/results/instagram-icon.png`}
        className="instagramIcon"
      />
      <div className="textContainer fullWidth flexCentered">
        <Subheading
          colourScheme={SubheadingColourScheme.GREY_TEXT_WHITE_SHADOW}
        >
          Did my numbers <strong>win?</strong>
        </Subheading>
        <h4>Watch our LIVE draws on Instagram</h4>
        <p>
          Follow us on Instagram (
          <a href="https://www.instagram.com/daymadeuk/" target="_blank">
            @daymadeuk
          </a>
          ) to watch us draw the winning numbers for our Friday Weekly Draw live
          every Friday at 5pm!
        </p>
      </div>

      <style jsx>
        {`
          .instagramIcon {
            width: 50px;
            margin-bottom: 2em;
          }

          :global(.followUsOnInstagramGreenPageSection .subheading) {
            max-width: 250px;
          }

          h4 {
            text-transform: none;
            letter-spacing: 0;
            margin-top: 0;
          }

          @media (min-width: 550px) {
            :global(.followUsOnInstagramGreenPageSection) {
              flex-direction: row !important;
            }

            .instagramIcon {
              width: 100px;
              margin-bottom: 0;
            }

            .textContainer {
              align-items: flex-start;
              text-align: left;
              margin-left: 2em;
            }

            :global(.followUsOnInstagramGreenPageSection .subheading) {
              width: 100%;
              max-width: 100%;
              text-align: left;
              margin-left: -0.1em;
            }
          }

          @media (min-width: 800px) {
            .instagramIcon {
              width: 120px;
            }

            h4 {
              font-size: 1.2em;
            }

            .textContainer {
              margin-left: 3em;
            }

            :global(.followUsOnInstagramGreenPageSection .subheading) {
              font-size: 2.5em;
            }
          }

          @media (min-width: 1000px) {
            h4 {
              font-size: 1.3em;
            }

            :global(.followUsOnInstagramGreenPageSection .subheading) {
              font-size: 2.7em;
            }
          }
        `}
      </style>
    </GreenPageSection>
  );
};

export default FollowUsOnInstagramGreenPageSection;
